import React, { useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import Login from '../components/Login/Login';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
    const navigate = useNavigate();
    const { token, login } = useAuth(); // Destructure the token and login function from the context

    useEffect(() => {
        if (token) {
            navigate('/dashboard'); // Redirect to dashboard if token exists
        }
    }, [token, navigate]);

    const handleLogin = async (username: string, password: string, newPassword?: string) => {
        try {
            await login(username, password);
            navigate('/dashboard'); // Navigate to dashboard after login
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    return (
        <div>
            <Login onLogin={handleLogin} />
        </div>
    );
};

export default LoginPage;
